import { PublicClientApplication } from "@azure/msal-browser";
import { buildTenantAuthority } from "@app/helpers/auth/auth.helper";
import { msalInstance } from "@app/helpers";
import { useToken } from "./useToken";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalConfig } from "@app/api";
import { useAuth } from "./useAuth";

export const useCustomMsal = () => {
  msalInstance.initialize();
  const { saveTokens } = useToken();
  const { login } = useAuth();

  const refreshToken = async () => {
    try {
      let activeInstance = msalInstance;
      const storedTenant = localStorage.getItem("authTenant");
      if (storedTenant) {
        const tenant = JSON.parse(storedTenant);
        activeInstance = new PublicClientApplication({
          auth: {
            clientId: tenant.clientId,
            authority: buildTenantAuthority(tenant),
            knownAuthorities: [new URL(tenant.instance).hostname],
            redirectUri: msalConfig.auth.redirectUri,
          },
          cache: { cacheLocation: "localStorage" },
        });
      }
      await activeInstance.initialize();
      const account = activeInstance.getAllAccounts()[0];
      if (!account) return null;
      const response = await activeInstance.acquireTokenSilent({ scopes: [], account });
      saveTokens({ token: response.idToken });
      return response.idToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // Don't redirect in background refresh
        console.log("[DEBUG] MSAL interaction required");
      }
      return null;
    }
  };

  const checkLoginAuthentication = async () => {
    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      login(response);
    } else {
      const currentAccounts = msalInstance.getAllAccounts();
      if (!currentAccounts.length) {
        msalInstance.loginRedirect({
          scopes: [],
          redirectStartPage: msalConfig.auth.redirectUri,
        });
        return;
      }
    }
  };

  return {
    refreshToken,
    checkLoginAuthentication,
  };
};
